var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92308 5.30769L9.92308 8.30769C10.0769 8.46154 10.0769 8.69231 9.92308 8.84615L8.84615 9.92308C8.69231 10.0769 8.46154 10.0769 8.30769 9.92308L5.30769 6.92308C5.15385 6.76923 4.92308 6.76923 4.76923 6.92308L1.76923 9.92308C1.61538 10.0769 1.38462 10.0769 1.23077 9.92308L0.153846 8.84615C0 8.69231 0 8.46154 0.153846 8.30769L3.15385 5.30769C3.30769 5.15385 3.30769 4.92308 3.15385 4.76923L0.115385 1.73077C-0.0384615 1.57692 -0.0384615 1.34615 0.115385 1.19231L1.19231 0.115385C1.34615 -0.0384615 1.57692 -0.0384615 1.73077 0.115385L4.76923 3.15385C4.92308 3.30769 5.15385 3.30769 5.30769 3.15385L8.30769 0.153846C8.46154 0 8.69231 0 8.84615 0.153846L9.92308 1.23077C10.0769 1.38462 10.0769 1.61538 9.92308 1.76923L6.92308 4.76923C6.80769 4.92308 6.80769 5.15385 6.92308 5.30769V5.30769Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.59a98e6f341fbbaf399fac5ddbb930c9.svg";
export { ForwardRef as ReactComponent };